module.exports = __webpack_public_path__ + "img/gmhy.4b5d7c12.png";